"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![LineGraphIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE2IDE1Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+TGluZUdyYXBoPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxnIGlkPSJMYXllcl8xLTItMiIgZGF0YS1uYW1lPSJMYXllciAxLTIiPgogICAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE1LjUsMTRIMVYxMi41TDUuNjYsNy4wN2w0LjY5LDEuNDdhLjUyLjUyLDAsMCwwLC40OC0uMWw1LTQuNDZhLjUuNSwwLDAsMCwwLS43MWgwYS41LjUsMCwwLDAtLjcsMEwxMC4zOCw3LjUsNS42NSw2YS41LjUsMCwwLDAtLjUzLjE1TDEsMTFWLjVBLjUuNSwwLDAsMCwuNSwwLC41LjUsMCwwLDAsMCwuNXYxNGEuNS41LDAsMCwwLC41LjVoMTVhLjUuNSwwLDAsMCwwLTFaIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=)
 */
exports.LineGraphIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16 15", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M15.5 14H1v-1.5l4.66-5.43 4.69 1.47a.52.52 0 0 0 .48-.1l5-4.46a.5.5 0 0 0 0-.71.5.5 0 0 0-.7 0L10.38 7.5 5.65 6a.5.5 0 0 0-.53.15L1 11V.5A.5.5 0 0 0 .5 0a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 0-1z" })));
};
//# sourceMappingURL=Icon.LineGraph.js.map